import createIcon from '../../createIcon';

/**
 * @component @name FormatUnderlined
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMTdDMTUuMzEgMTcgMTggMTQuMzEgMTggMTFWM0gxNS41VjExQzE1LjUgMTIuOTMgMTMuOTMgMTQuNSAxMiAxNC41QzEwLjA3IDE0LjUgOC41IDEyLjkzIDguNSAxMVYzSDZWMTFDNiAxNC4zMSA4LjY5IDE3IDEyIDE3Wk01IDE5VjIxSDE5VjE5SDVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FormatUnderlined = createIcon('FormatUnderlined', [
  [
    'path',
    {
      d: 'M12 17C15.31 17 18 14.31 18 11V3H15.5V11C15.5 12.93 13.93 14.5 12 14.5C10.07 14.5 8.5 12.93 8.5 11V3H6V11C6 14.31 8.69 17 12 17ZM5 19V21H19V19H5Z',
      key: '1vik3k',
    },
  ],
]);

export default FormatUnderlined;
